(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hld-checklist-gate"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY = 'hld-checklist-unlocked';
    var root = document.querySelector('[data-hld-gate]');
    if (!root) return;
    var card = root.querySelector('[data-hld-gate-card]');
    var body = root.querySelector('[data-hld-gate-content]');
    if (!card || !body) return;

    // remember: true = this device, 'session' = this visit, false = don't persist
    function unlock(remember) {
      try {
        if (remember === true) localStorage.setItem(KEY, '1');
        else if (remember === 'session') sessionStorage.setItem(KEY, '1');
      } catch (e) {}
      card.hidden = true;
      body.hidden = false;
    }

    var params = new URLSearchParams(location.search);
    var stored = false, session = false;
    try { stored = localStorage.getItem(KEY) === '1'; } catch (e) {}
    try { session = sessionStorage.getItem(KEY) === '1'; } catch (e) {}

    // Two tiers of unlock, deliberately.
    //
    // Giving an address on THIS device is a durable signal, so a form submit is
    // remembered in localStorage and they never see the gate again.
    //
    // `?unlocked=1` is not. It rides on the Welcome emails so subscribers aren't
    // asked twice for the address they just gave — but it is a shareable string
    // in a URL, and when it wrote localStorage a single click unlocked that
    // browser permanently. That is why Alan reported "no opt-in to see the
    // content" on 2026-08-05 while a clean session showed the gate correctly:
    // he had followed an email link earlier and his browser stayed open. It now
    // unlocks the VISIT (sessionStorage), which is all that journey needs.
    if (card.querySelector('.hld-signup__success')) unlock(true);
    else if (params.get('unlocked') === '1') unlock('session');
    else if (stored || session) unlock(false);

    // Remember the unlock at the moment of submit, not only on the way back.
    //
    // The form posts natively and the page reloads, and the success panel is the
    // only server-side signal that it worked — but Shopify can bounce the post
    // (a captcha challenge is the common one) and redirect back with no success
    // panel and no error. That left someone who HAD filled the form in staring
    // at the gate again. The address is captured or not on Shopify's side either
    // way; holding the content back on top of that just punishes the visitor.
    // It is a lead magnet, not a paywall.
    var form = card.querySelector('form.hld-signup__form');
    if (form) form.addEventListener('submit', function () {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hld-cross-sell"] && !Shopify.designMode) return;
  try {
    
  // Async-load Shopify Product Recommendations into the cross-sell slot.
  // Tries each intent in data-intents order — "complementary" (curated in the
  // Search & Discovery app) first, then "related" (Shopify's auto algorithm) as
  // a fallback — so merchant curation reflects but the row is never empty.
  // Unique tag name to avoid clashing with any theme element.
  if (!customElements.get('hld-recommendations')) {
    customElements.define('hld-recommendations', class extends HTMLElement {
      connectedCallback() {
        const base = this.dataset.base;
        if (!base) return; // already a rendered result, not a shell — nothing to fetch
        const intents = (this.dataset.intents || 'related').split(',').filter(Boolean);
        this.tryIntent(base, intents, 0);
      }
      tryIntent(base, intents, i) {
        if (i >= intents.length) { this.remove(); return; }
        fetch(base + '&intent=' + intents[i])
          .then((r) => r.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, 'text/html');
            const fresh = doc.querySelector('.hld-cross-sell');
            const grid = fresh && fresh.querySelector('.hld-cross-sell__grid');
            if (grid && grid.children.length) {
              this.replaceWith(fresh); // populated (recs or manual fallback) — swap in
            } else {
              this.tryIntent(base, intents, i + 1); // empty for this intent — try the next
            }
          })
          .catch((e) => { console.error('[hld-cross-sell]', e); this.tryIntent(base, intents, i + 1); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
